import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/article.gif'
import _imports_1 from '@/assets/instrtype.gif'
import _imports_2 from '@/assets/serial.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Добавление инструмента")
], -1)
const _hoisted_2 = { class: "form__body" }
const _hoisted_3 = { style: {"display":"block"} }
const _hoisted_4 = {
  class: "form__image",
  src: _imports_0,
  alt: "article"
}
const _hoisted_5 = { style: {"display":"block"} }
const _hoisted_6 = {
  class: "form__image",
  src: _imports_1,
  alt: "instrtype"
}
const _hoisted_7 = { style: {"display":"block"} }
const _hoisted_8 = {
  class: "form__image",
  src: _imports_2,
  alt: "serial"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "checkbox__text" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "body__actions actions--end" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-green btn-medium mt-8" }, "Подтвердить")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form__input form__input__required", {
                        'form__input--invalid': _ctx.tool_form$.article.$error,
                    }]),
          placeholder: "Артикул *",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.article) = $event)),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.img_state.is_article_img_showed = true)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.img_state.is_article_img_showed = false))
        }, null, 34), [
          [
            _vModelText,
            _ctx.state.article,
            void 0,
            { trim: true }
          ]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
          [_vShow, _ctx.img_state.is_article_img_showed]
        ])
      ]),
      _createElementVNode("span", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form__input", {
                        'form__input--invalid': _ctx.tool_form$.type.$error,
                    }]),
          placeholder: "Тип *",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.type) = $event)),
          onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.img_state.is_type_img_showed = true)),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.img_state.is_type_img_showed = false))
        }, null, 34), [
          [
            _vModelText,
            _ctx.state.type,
            void 0,
            { trim: true }
          ]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
          [_vShow, _ctx.img_state.is_type_img_showed]
        ])
      ]),
      _createElementVNode("span", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form__input", {
                        'form__input--invalid': _ctx.tool_form$.serial_number.$error,
                    }]),
          placeholder: "Серийный номер *",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.serial_number) = $event)),
          onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.img_state.is_serial_number_img_showed = true)),
          onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.img_state.is_serial_number_img_showed = false))
        }, null, 34), [
          [_vModelText, _ctx.state.serial_number]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
          [_vShow, _ctx.img_state.is_serial_number_img_showed]
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "date",
        class: "form__input",
        placeholder: "Дата продажи",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.sell_date) = $event))
      }, null, 512), [
        [_vModelText, _ctx.state.sell_date]
      ]),
      _withDirectives(_createElementVNode("textarea", {
        id: "failure_description",
        class: "form__textarea",
        placeholder: "Описание неисправности",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.failure_description) = $event))
      }, null, 512), [
        [_vModelText, _ctx.state.failure_description]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CargoTypes, (cargo_type, i) => {
        return (_openBlock(), _createElementBlock("label", {
          key: `cargoType-${i}`,
          class: "form__checkbox"
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checkbox__square",
            value: cargo_type.id,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.selected_cargo_types) = $event))
          }, null, 8, _hoisted_9), [
            [_vModelCheckbox, _ctx.state.selected_cargo_types]
          ]),
          _createElementVNode("span", _hoisted_10, _toDisplayString(cargo_type.name), 1)
        ]))
      }), 128)),
      _hoisted_11
    ])
  ], 32))
}